import { render } from "./Magazzino.vue?vue&type=template&id=75209272&scoped=true"
import script from "./Magazzino.vue?vue&type=script&lang=js"
export * from "./Magazzino.vue?vue&type=script&lang=js"

import "./Magazzino.vue?vue&type=style&index=0&id=75209272&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75209272"]])

export default __exports__